import React, {Component} from 'react';
import {Empty, Button, Col, Modal, Row, Select, Table} from "antd";
import MaskComponent from "./common/MaskComponent";
import {Typography} from 'antd';
import QRCode from 'qrcode.react';
import utils from "../common/utils";
import {Translation} from "react-i18next";
import {create, isEmpty, map, get, values, first, find} from 'lodash';
import consts, {PREFIX_FRONT_URL} from "../consts";
import './router/walletStyle.scss'
import {Flex} from 'antd-mobile';
import EncodedDataImage from './common/EncodedDataImage'
import {LinkOutlined} from "@ant-design/icons";
import {CopyToClipboard} from "react-copy-to-clipboard/lib/Component";

const {Option} = Select;

class DepositComponent extends Component {
  
  columns = (t) => [
    {
      align: "center",
      title: t('user.transaction.id'),
      width: 60,
      dataIndex: 'id',
    },
    {
      title: t('user.deposit.currency'),
      width: 200,
      dataIndex: 'currency',
      key: 'currency',
      render: this.getName
    },
    {
      align: "center",
      title: t('user.deposit.fee'),
      width: 100,
      dataIndex: 'fee',
      key: 'fee',
      render: (fee) => utils.formatCurrency(fee)
    },
    {
      align: "center",
      title: t('user.deposit.amount'),
      width: 150,
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => utils.formatCurrency(amount)
    },
    {
      title: t('user.deposit.status'),
      width: 130,
      dataIndex: 'status',
      key: 'status',
      render: (status) => <div className='d-flex align-items'>
        <div className="mr-medium">{`${(t(utils.parseTranStatus(status)))}`}</div>
        {/*<span*/}
        {/*  className={status === 0 ? "icon-radix-icons_checkbox icon-success" : "icon-ic_baseline-cancel-presentation icon-failed"}/>*/}
      </div>
    },
    {
      align: "center",
      title: t('user.deposit.deposit_date'),
      width: 200,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (createdAt) => utils.formatTimeFromUnix(createdAt, 'DD/MM/YYYY HH:mm:ss'),
    },
    {
      align: "center",
      width: 100,
      title: t('user.withdrawal.detail'),
      dataIndex: 'tx_hash',
      key: 'tx_hash',
      render: (tx_hash, item) => this.getLink(tx_hash, item),
    },
  ]
  
  constructor(props) {
    super(props);
    
    this.state = {
      value: '',
      coin: undefined,
      visible: false,
      init: true,
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.useQuery = this.useQuery.bind(this);
    this.qrCodeNode = React.createRef();
  }
  
  
  useQuery() {
    return new URLSearchParams(this.props.history.location.search);
  }
  
  getLink = (tx_hash, item) => {
    const { coins } = this.props;
    return (tx_hash && item.is_external ?
        <a className="fz-16" title={`${coins[item.currency]?.transaction_explorer}/tx/${tx_hash}`}
           href={`${coins[item.currency]?.transaction_explorer}/tx/${tx_hash}`} target="_blank">
          <LinkOutlined />
        </a> : ''
    )
  }
  
  getName = (symbol) => {
    const { coins } = this.props;
    
    return <div className='d-flex'>
      <div style={{ width: "45px", textAlign: "left" }}>
        <div style={{
          backgroundImage: `url(${coins[symbol]?.icon_image || ''})`, height: '26px',
          width: '26px',
          backgroundSize: 'contain',
          marginRight: "20px",
          display: 'block',
          backgroundRepeat: 'no-repeat',
          fontWeight: 600,
          color: 'black',
        }} alt={symbol} />
      </div>
      <div style={{ width: "50px", textAlign: "left", fontWeight: "bold", lineHeight: '28px' }}>{symbol}</div>
      <div style={{
        width: "150px",
        textAlign: "left",
        fontSize: "12px",
        lineHeight: "28px",
        color: "#76808F",
      }}>{coins[symbol]?.name ?? ''}</div>
    </div>
  }
  
  handleSearch() {
  }
  
  UNSAFE_componentWillReceiveProps(nextProps, propsContext) {
    if (this.state.init && utils.hash(nextProps.coins || []) !== utils.hash(this.props.coins || [])) {
      const query = this.useQuery();
      
      let coin = find(values(nextProps.coins), ['symbol', query.get('coin') || 'ETH']);
      this.setState({init: false, coin,});
    }
  }
  
  componentDidMount() {
    if (!isEmpty(this.props.coins)) {
      const query = this.useQuery();
      this.handleChange(query.get("coin") || 'ETH');
    }
    this.fetchDepositHistory(0, 5);
  }
  
  fetchDepositHistory(pos, count) {
    this.props.onFetchTransactionHistory({
        pos,
        count,
        trans_type: window.c.TRANSACTION_TYPE_DEPOSIT,
        status: -1,
      },
    );
  }
  
  // handleChange(coin) {
  //   this.setState({coin: window._.find(window._.values(this.props.coins), ['symbol', coin])});
  // }
  handleChange = (symbol = 'ETH') => {
    let coin = find(values(this.props.coins), ['symbol', symbol]);
    this.setState({
      coin,
    });
    // this.props.fetchUserVolume24hAction({currency: get(coin, 'coin')});
    // this.clearErrors();
  }
  
  render() {
    // const firstCoin = this.props.coins[coinName] || {
    //   symbol: "USDT",
    //   name: "Tether",
    //   icon_image: "data:image/png;base64,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",
    // };
    const coinSymbol = get(this.state.coin, 'symbol', '');
    const coinType = get(this.state.coin, 'type', '');
    const coin = get(this.state.coin, 'coin', '');
    // const coinSymbol = get(this.state.coin || firstCoin, 'symbol', '');
    // const coin = get(this.state.coin || firstCoin, 'coin', '');
    const address = get(this.props.balances[`${coin}`], 'blockchain_address', '');
    const pubkey = get(this.props.balances[`${coin}`], 'pubkey', '');
    const pubkeyAddress = coinType === consts.CUSTOM_COIN ? pubkey : address;
    
    return (
      <Translation>
        {(t) =>
          <>
            <div className="wallet-right-content">
              <div>{t('user.menu.deposit')}</div>
              <div className="text-left wallet-select-deposit">
                {this.state.coin && <Select
                  showSearch
                  // placeholder="placeholder"
                  defaultValue={
                    <div>
                      <div style={{
                        display: 'block',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                        height: '24px',
                        width: '24px',
                        backgroundImage: `url("${get(this.state.coin, 'icon_image', '')}")`,
                        float: "left"
                      }} className="mr-small mt-ex-small"/>
                      <div className="ln-normal pr-large">
                        {coinSymbol} {get(this.state.coin, 'name', '')}
                      </div>
                    </div>}
                  style={{color: 'dark', width: '368px'}}
                  defaultActiveFirstOption={true}
                  showArrow={true}
                  filterOption={false}
                  onSearch={this.handleSearch}
                  onChange={this.handleChange}
                  notFoundContent={null}
                  size={"large"}
                >
                  {map(values(this.props.coins), (coin) => {
                    return <Option key={coin.symbol}>
                      <div style={{
                        display: 'block',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                        height: '24px',
                        width: '24px',
                        backgroundImage: `url("${coin.icon_image}")`,
                        float: "left"
                      }} className="mr-small mt-ex-small"/>
                      <div className="ln-normal pr-large">
                        {coin.symbol} <span>{coin.name}</span>
                      </div>
                    </Option>
                  })}
                </Select>}
              </div>
            </div>
            <div className="account-balance-wrap user-wallet">
              <div className="balance-header text-left user-wallet-header">
                <Row>
                  <Col span={12}>
                    <div className="label mr-small">
                      {t('user.deposit.total_balance')}:
                    </div>
                    <div className="value align-self" style={{fontSize: 32}}>
                      {utils.formatCurrency(get(this.props.balances[coin], 'balance', '0.00000000'))} {coinSymbol}
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="label mr-small">
                      {t('user.deposit.available_balance')}:
                    </div>
                    <div className="value align-self" style={{fontSize: 32}}>
                      {utils.formatCurrency(get(this.props.balances[coin], 'available_balance', '0.00000000'))} {coinSymbol}
                    </div>
                  </Col>
                </Row>
              </div>

              <Row className="deposit-body">
                <Col className="balance-body deposit-body-1">
                  <div className="text-left p-medium ">
                    {/*<div className="select-network">*/}
                    {/*	<div className="label">*/}
                    {/*		{t('user.withdrawal.select_network')}*/}
                    {/*	</div>*/}
                    {/*	<div className="d-inline">*/}
                    {/*		<Button size={"large"} className="btn-min-width">*/}
                    {/*			<span className="bold px-small">{coinSymbol}</span>*/}
                    {/*		</Button>*/}
                    {/*	</div>*/}
                    {/*</div>*/}
                    {/*todo save address*/}
                    {/*<div className="pb-small text-right clearfix">*/}
                    {/*	<span onClick={() => this.setState({isVisible: true})} className="link">Save address</span>*/}
                    {/*</div>*/}
                    <p className='text-normal fontW-700'>{t('user.withdrawal.tips')}</p>
                    <div className="op-80 d-flex align-items text-normal mb-small">
                      <div className="icon-gridicons_checkmark icon-checkmark"></div>
                      <div>{t('user.withdrawal.coins_confirmations')}</div>
                    </div>
                    <div className="op-80 d-flex align-items text-normal mb-small">
                      <div className="icon-gridicons_checkmark icon-checkmark"></div>
                      <div>{t('user.withdrawal.until_withdrawals')}</div>
                    </div>
                    
                    
                    {/* <div className="notes mt-medium fz-medium">
									<div className="bold">
										{t('user.withdrawal.send_address', {coinSymbol})}
									</div>
									<div className="op-80">
										{t('user.withdrawal.sending_deposit', {coinSymbol})}
									</div>
								</div> */}
                    {/* {!isEmpty(currencyMarkets[coinSymbol]) && <div className="mt-small">
									<div className="label">
										{t('user.withdrawal.go_trade')}:
									</div>
									<div className="d-flex f-wrap link-coin">
										{
											map(currencyMarkets[coinSymbol], ({coin, currency}) => <div key={`${coin}:${currency}`}
											                                                            onClick={() => {
												                                                            window.h.push(`${PREFIX_FRONT_URL}/?currency=${coin}/${currency}`);
											                                                            }}>
												{coin}/{currency}
											</div>)
										}
									</div>
								</div>} */}
                  </div>
                </Col>
                
                <Col className="balance-body deposit-body-1">
                  <div className="right-deposit text-left p-medium deposit-body-2">
                    {/*<div className="select-network">*/}
                    {/*	<div className="label">*/}
                    {/*		{t('user.deposit.select_network')}*/}
                    {/*	</div>*/}
                    {/*	<div className="d-inline">*/}
                    {/*		<Button size={"large"} className="btn-min-width">*/}
                    {/*			<span className="bold px-small">{ coinSymbol }</span>*/}
                    {/*		</Button>*/}
                    {/*	</div>*/}
                    {/*</div>*/}
                    <div className="address">
                      <div className="btn-controls mt-small text-center">
                        {/*<Button size={"large"} className="btn-min-width text-left"*/}
                        {/*        onClick={() => this.setState({visible: true})}>*/}
                        {/*	<span className="bold px-small"><i*/}
                        {/*		className="icon-qrcode mr-ex-small"/> {t('user.deposit.show_qr')}</span>*/}
                        {/*</Button>*/}
                        <QRCode className="text-center" value={pubkeyAddress} style={{border: '2px solid', padding: '5px'}}
                                ref={this.qrCodeNode}/>
                      </div>
                      <div className="text-center">
                        {t('user.deposit.address', {coinSymbol})}
                      </div>
                    
                    </div>
                    <div className="notes">
                      <p className='text-normal fontW-700'>{t('user.deposit.send_only_addr', {coinSymbol})}</p>
                      <div className="op-80 d-flex align-items text-normal mb-small">
                        <div className="icon-gridicons_checkmark icon-checkmark"></div>
                        <div>{t('user.deposit.send_deposit', {coinSymbol})}</div>
                      </div>
                      <div className="op-80 d-flex align-items text-normal mb-small">
                        <div className="icon-gridicons_checkmark icon-checkmark"></div>
                        <div className='d-flex align-items link bold'>
                          <CopyToClipboard text={pubkeyAddress} onCopy={() => utils.showNotification(t("common.notification"), t("user.deposit.copy"))}>
                            <div className="pointer">{t('user.deposit.copy_address')}</div>
                          </CopyToClipboard>
                          {/*<span><Typography.Paragraph copyable={{text: pubkeyAddress}} style={{margin: 0}}/></span>*/}
                        </div>
                      </div>
                      {
                        coinType === consts.CUSTOM_COIN ?
                          <div className='text-normal ellipsis' title={pubkey}>{t('user.deposit.pubkey')} : {pubkey}</div> :
                          <div className='text-normal ellipsis' title={address}>{t('user.deposit.address')} : {address}</div>
                      }
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="deposit-bottom ">
                <h2 className="text-black text-left fz-24 bold">{t('user.deposit.recent_history')}</h2>
                <Table columns={this.columns(t)}
                       locale={{
                         emptyText: (<Empty description={<span className="bold">{window.$t('common.empty')}</span>}/>)
                       }}
                       dataSource={get(this.props.trans, 'withdrawalHistory', [])}
                       pagination={{
                          showQuickJumper: true,
                         defaultPageSize: 5,
                         total: get(this.props.trans, 'totalCount', 0),
                         hideOnSinglePage: true,
                         responsive: true,
                         onChange: (page, pageSize) => {
                           this.fetchDepositHistory((page - 1) * pageSize, pageSize)
                         }
                       }}
                       style={{ fontSize: 14}}
                />
              </div>
              
              {/*<Modal*/}
              {/*	title={t('user.deposit.modal_title', {coinSymbol})}*/}
              {/*	className="text-center"*/}
              {/*	visible={this.state.visible}*/}
              {/*	onOk={() => {*/}
              {/*		this.setState({visible: false})*/}
              {/*	}}*/}
              {/*	onCancel={() => {*/}
              {/*		this.setState({visible: false})*/}
              {/*	}}*/}
              {/*>*/}
              {/*	<div>*/}
              {/*		<QRCode value={address} ref={this.qrCodeNode}/>*/}
              {/*	</div>*/}
              {/*	<div className="mt-small color-primary fz-14">*/}
              {/*		{address}*/}
              {/*	</div>*/}
              {/*</Modal>*/}
            </div>
          </>
        }
      </Translation>
    
    );
  }
}

export default DepositComponent;
